<section
  class="flex flex-col h-full p-5 bg-white shadow-lg rounded-xl"
  [class.ltr]="languageService.getLang() === 'en'"
  [class.rtl]="languageService.getLang() === 'ar'"
>
  <!-- Title + Status -->
  <div class="flex items-start gap-3 min-h-13.75">
    <h3 class="text-xl font-bold text-(--color-secondary) flex-1">
      {{ project.title }}
    </h3>

    @if (project.status) {
      <span
        class="bg-(--color-secondary) text-(--color-main) text-[11px] px-2 py-1 rounded-md flex items-center gap-1"
      >
        <span class="w-2 h-2 bg-(--color-main) rounded-full"></span>
        {{ getStatusLabel(project.status) }}
      </span>
    }
  </div>

  <!-- Phase -->
  <div class="mt-1 text-(--text-muted)">
    {{ project.phase?.name }}
  </div>

  <!-- Details -->
  <div class="mt-6 space-y-4 text-(--color-secondary)">
    <div class="flex justify-between">
      <span>{{ t('share_price') }}</span>
      <span class="font-bold">
        {{ project.price_per_share | number: '1.0-0' }} {{ currencyLabel }}
      </span>
    </div>

    <div class="flex justify-between">
      <span>{{ t('expected_return') }}</span>
      <span class="font-bold">{{ project.actual_roi_project }}%</span>
    </div>

    <div class="flex justify-between">
      <span>{{ t('min_contract') }}</span>
      <span class="font-bold">
        {{ project.minimum_investment_amount | number: '1.0-0' }} {{ currencyLabel }}
      </span>
    </div>

    <div class="flex justify-between">
      <span>{{ t('duration') }}</span>
      <span class="font-bold">{{ project.duration }} {{ t('month') }}</span>
    </div>

    <hr />

    <div class="flex justify-between pb-3">
      <span>{{ t('return') }}</span>
      <span class="font-bold">{{ project.phase?.description }}</span>
    </div>
  </div>

  <!-- Button -->
  <button
    (click)="onButtonClick()"
    [disabled]="isInvestDisabled"
    class="py-2 mt-auto mb-4 font-bold transition rounded-lg cursor-pointer"
    [ngClass]="
      isInvestDisabled
        ? 'bg-(--text-muted) text-white cursor-not-allowed'
        : 'bg-(--color-main) text-(--color-secondary) hover:opacity-90'
    "
  >
    {{ t(buttonLabelKey) }}
  </button>
</section>
